import React from "react";

export default function BlackDividerBottom() {
  return (
    <div style={{ lineHeight: 0 }}>
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        style={{ width: "100%", height: "80px", display: "block" }}
      >
        <defs>
          <linearGradient id="blackGradientBottom" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0d0d0f" />
            <stop offset="40%" stopColor="#111113" />
            <stop offset="100%" stopColor="#0b0b0c" />
          </linearGradient>
        </defs>

        <polygon
          points="0,0 0,120 1440,120"
          fill="url(#blackGradientBottom)"
        />
      </svg>
    </div>
  );
}